export default __webpack_public_path__ + "static/media/mini-loader.7be6cb3e.svg";